import api from "../../helpers";

/**
 *
 * @param {string} metaData
 * @returns
 */


export async function loadProjectDetailsAPI(projectarg){
    return await api
    .post("/auth/employee/getproject",projectarg)
    .then((resp)=>resp.data)
    .catch((error)=>Promise.reject(error));
}

export async function loadPhaseDetailsAPI(projectarg){
    return await api
    .post("/auth/employee/getphase",projectarg)
    .then((resp)=>resp.data)
    .catch((error)=>Promise.reject(error));
}

export function loadProjectDropdownAPI(metaData, method) {
  if (method === "post") {
    return api
        .post(`/protected/get${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
        .post(`/protected/get${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

const remotes = {
    loadProjectDetailsAPI,
    loadPhaseDetailsAPI,
    loadProjectDropdownAPI,
}

export default remotes;